import React, { useCallback } from 'react';

import { TableCell, TableRow } from '@occc/ui-design-system';
import { KioskAssetFragment } from '@occc/graphql';

import { ThumbnailImage } from '../thumbnail-image';

type AssetTableRowProps = {
  asset: KioskAssetFragment;
  isSelected: boolean;
  onSelect: (assetId: string) => void;
};

const AssignAssetTableRowComponent = ({ asset, isSelected, onSelect }: AssetTableRowProps) => {
  const { id, name, description, imageSet } = asset;
  const squareImageUrl = imageSet?.square;

  const handleClick = useCallback(() => {
    onSelect(id);
  }, [id, onSelect]);

  return (
    <TableRow
      onClick={handleClick}
      selected={isSelected}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <TableCell
        sx={{
          maxWidth: { xs: 200, md: 'none' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: { xs: 'nowrap', md: 'normal' },
        }}
      >
        {name || ''}
      </TableCell>
      <TableCell
        sx={{
          maxWidth: { xs: 200, md: 'none' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: { xs: 'nowrap', md: 'normal' },
        }}
      >
        {description || ''}
      </TableCell>
      <TableCell align='right'>
        <ThumbnailImage imageUrl={squareImageUrl} altText={name || 'Asset thumbnail'} size={40} />
      </TableCell>
    </TableRow>
  );
};

export const AssignAssetTableRow = React.memo<AssetTableRowProps>(AssignAssetTableRowComponent);
